import { render, staticRenderFns } from "./gamenews.vue?vue&type=template&id=523ea656&scoped=true&"
import script from "./gamenews.vue?vue&type=script&lang=js&"
export * from "./gamenews.vue?vue&type=script&lang=js&"
import style0 from "./gamenews.vue?vue&type=style&index=0&lang=css&"
import style1 from "./gamenews.vue?vue&type=style&index=1&id=523ea656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523ea656",
  null
  
)

export default component.exports